<template>
  <div>
    <v-navigation-drawer :value="drawer" app @transitionend="ShowEvent">
      <IphLogo />
      <v-divider></v-divider>
      <AvatarUser v-if="GET_user" />

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item link :to="{ name: 'invoice' }" color="red darken-2">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Notas Fiscais</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item link :to="{ name: 'transfer' }" color="red darken-2">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Transferencias</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn class="menu-bg-gradinte-iph-red white--text" block @click="ActionSignOut"
            >Sair</v-btn
          >
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import IphLogo from './IphLogo'
import AvatarUser from './AvatarUser'

import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  name: 'MainMenu',
  data: function () {
    return {
      verify: true,
      inset: false,
      model: 0,
      menuRh: false,
      menuComunication: false,
      menuEcommerce: false,
      menuCourse: false,
      menuUsers: false,
      activeLinkText: '',
      // activeCurrentPage: 'router-link-active',
      admins: [
        ['Management', 'mdi-home'],
        ['Settings', 'mdi-home'],
      ],
      cruds: [
        ['Create', 'add'],
        ['Read', 'insert_drive_file'],
        ['Update', 'update'],
        ['Delete', 'delete'],
      ],
    }
  },
  components: {
    IphLogo,
    AvatarUser,
  },
  computed: {
    ...mapState('menu', ['drawer']),
    ...mapGetters('auth', ['GET_user']),
  },
  methods: {
    ...mapActions('auth', ['ActionSignOut']),
    ...mapActions('menu', ['ActionSetDrawerFalse', 'ActionSetDrawerTrue']),
    ShowEvent(e) {
      let a = e.propertyName
      if (a == 'visibility' && this.verify) {
        this.ActionSetDrawerFalse()
        this.verify = false
      } else if (a == 'visibility' && !this.verify) {
        this.ActionSetDrawerTrue()
        this.verify = true
      }
    },
  },
}
</script>
